import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import PanelLayout, { IPanelLayoutConfig } from "./PanelLayout";

@Form({title: "Container"})
export default class ContainerConfig {

	@Input({type: InputType.PANELS, title: "Children"})
	public children: string[] = [];

	@Input({type: InputType.CHECKBOX, title: "No wrapper"})
	public noWrapper: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable layout"})
	public layoutEnabled: boolean;

	@Input({type: PanelLayout.getLayoutInput("children", "layoutEnabled"), title: "Edit layout"})
	public layout: ILayout<IPanelLayoutConfig>;

}



// WEBPACK FOOTER //
// ./src/panels/container/ContainerConfig.tsx